varying vec2 v_texCoord;

void main() {
    gl_Position = vec4(position.xy, 0.0, 1.0);
    v_texCoord = position.xy * 0.5 + 0.5;
}
